import Icon from "@/components/Icon/Icon";
import { HStack } from "@/components/Layout";
import { cn } from "@/lib/cn";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { TaskStatus } from "../../-constants";

type Props = {
  className?: string;
};

export function Footer({ className }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.laborCore.operationPackages.status",
  });

  return (
    <HStack
      className={cn(
        "p-3 gap-3 w-full border-t border-neutral-on-fill",
        className,
      )}
    >
      <Icon
        iconName="Paperclip"
        text={t(TaskStatus.attachment)}
        colorVariant="primaryOnNeutralMuted"
      />
    </HStack>
  );
}
